import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _serialNumberGetters;

import _identity from 'lodash/identity';
import _toNumber from 'lodash/toNumber';
var SERIAL_NUMBER_TYPE = {
  ALPHABETICAL: 'ALPHABET',
  NUMERICAL: 'NUMERIC'
};
export var parseNumberFromText = function parseNumberFromText(text) {
  return parseInt(text, 10);
};
export var parseTextFromNumber = function parseTextFromNumber(number) {
  return number.toString();
};
export var parseHours = function parseHours(value) {
  if (!value) return ''; // return parseFloat(value).toFixed(2);

  return value;
};
export var parseFloats = function parseFloats() {
  var decimalPlace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return function (value) {
    if (!value) return '';
    return parseFloat(parseFloat(value).toFixed(decimalPlace));
  };
};
var getNumericalSerial = _identity;

var getUppercaseAlphabeticalSerial = function getUppercaseAlphabeticalSerial(number) {
  var startIndex = 'A'.charCodeAt(0) + (number - 1);
  return String.fromCharCode(startIndex);
};

var getLowercaseAlphabeticalSerial = function getLowercaseAlphabeticalSerial(number) {
  var startIndex = 'a'.charCodeAt(0) + (number - 1);
  return String.fromCharCode(startIndex);
};

var serialNumberGetters = (_serialNumberGetters = {}, _defineProperty(_serialNumberGetters, SERIAL_NUMBER_TYPE.NUMERICAL, getNumericalSerial), _defineProperty(_serialNumberGetters, "UPPERCASE_ALPHABETS", getUppercaseAlphabeticalSerial), _defineProperty(_serialNumberGetters, SERIAL_NUMBER_TYPE.ALPHABETICAL, getUppercaseAlphabeticalSerial), _defineProperty(_serialNumberGetters, "LOWERCASE_ALPHABETS", getLowercaseAlphabeticalSerial), _serialNumberGetters);
export var parseSerialNumberByType = function parseSerialNumberByType(number) {
  var serialNumberType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SERIAL_NUMBER_TYPE.NUMERICAL;
  var serialNumberGetter = serialNumberGetters[serialNumberType];
  if (serialNumberGetter) return serialNumberGetter(_toNumber(number));
  return number;
};